
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Filter = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M21.1,2.8H3.9A1.1,1.1,0,0,0,3,4.5l6,9.1v8.6h4a2.9,2.9,0,0,0,3-3V13.6l6-9.1A1.1,1.1,0,0,0,21.1,2.8Zm-6.3,10-.3.3v6.1A1.5,1.5,0,0,1,13,20.7H10.5V13.1l-.3-.3L4.6,4.3H20.4Z"></path>
        </g>
      </g>
    </IconBase>);
};

Filter.defaultProps = {
  title: 'Filter',
};

export default Filter;
